<template>
    <el-container>
        <el-header>
            <commonheader :isNavShow='true'></commonheader>
        </el-header>

        <el-container class="el-container-master">
            <el-aside style="width:220px">
                <leftMenu></leftMenu>
            </el-aside>
            <el-main>
                <section class="flex">
                    <exit></exit>
                    
                    <div class="content">
                        <div class="mockExamCont">
                            <div class="selectBox">
                                <el-select v-model="value" placeholder="请选择">
                                    <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>                                 
                            </div>

                            <div class="mockExamTable">
                                <el-table
                                    :data="tableData"
                                    stripe
                                    style="width: 100%"
                                    class="myOrderTableHead">
                                    <el-table-column
                                        prop="courseName"
                                        label="模考时间"
                                        >
                                    </el-table-column>
                                    <el-table-column
                                        prop="orderNumber"
                                        label="答题时间"
                                        >
                                    </el-table-column>
                                    <el-table-column
                                        prop="payTime"
                                        label="正确题数"
                                        >
                                    </el-table-column>
                                    <el-table-column
                                        prop="payMoney"
                                        label="错误题数"
                                        >
                                    </el-table-column>
                                    <!-- <el-table-column
                                        prop="payMethod"
                                        label="支付方式"
                                        width="105">
                                    </el-table-column>

                                    <el-table-column
                                        prop="operate"
                                        label="操作"
                                        width="147">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.operate.electronicInvoiceleStatus == 1" class="seeElectronicInvoice"><router-link to="/requestInvoice">申请电子发票</router-link></span>                                   
                                            <span v-if="scope.row.operate.electronicInvoiceleStatus == 2" class="alreadyFinishStatus" prop="operate">已申请电子发票</span>
                                            <span v-if="scope.row.operate.electronicInvoiceleStatus == 3" class="seeElectronicInvoice" prop="operate">查看电子发票</span>
                                            <span v-if="scope.row.operate.refundStatus == 1 && scope.row.operate.electronicInvoiceleStatus == 1" class="seeElectronicInvoice blueGradient" prop="operate">申请退款</span>
                                            <span v-if="scope.row.operate.refundStatus == 2" class="seeElectronicInvoice littleBlueGradient" prop="operate">退款中</span>
                                            <span v-if="scope.row.operate.refundStatus == 3" class="alreadyFinishStatus" prop="operate">已完成退款</span>
                                        </template>
                                    </el-table-column>        -->
                                    
                                </el-table>
                            </div>

                            <div class="againExamBtn blueGradient">在次考试</div>



                        </div>
                    


                    </div>




                </section>
            </el-main>
        </el-container>
    </el-container>

</template>

<script>

import commonheader from '../common/commonHeader.vue' //头部组件
import leftMenu from "../common/leftMenu.vue"; //头部组件
import exit from "../common/exit.vue"; //头部组件


export default {
  name: "index",
  components: {
    commonheader,
    exit,
    leftMenu,

  },
  data() {
    return {
        
         options: [{
            value: '选项1',
            label: '黄金糕'
          }, {
            value: '选项2',
            label: '双皮奶'
          }, {
            value: '选项3',
            label: '蚵仔煎'
          }, {
            value: '选项4',
            label: '龙须面'
          }, {
            value: '选项5',
            label: '北京烤鸭'
          }],
          value: '',     

        tableData: [
                {
                    courseName: '湖南省药师协会会费',
                    orderNumber: '202005168638292402',
                    payTime: '2020.12.12  14:19',
                    payMoney: '30.00',
                    payMethod: '办公室转学员',
                    operateId: '1',
                    operate: {
                        'electronicInvoiceleStatus': 1,  // 1申请电子发票 2已申请电子发票 3查看电子发票
                        'refundStatus': 1 // 1申请退款 2退款中 3已完成退款s
                    }
                }, 
                 {
                    courseName: '湖南省药师协会会费',
                    orderNumber: '202005168638292402',
                    payTime: '2020.12.12  14:19',
                    payMoney: '30.00',
                    payMethod: '办公室转学员',
                    operate: {
                        'electronicInvoiceleStatus': 2,  // 1申请电子发票 2已申请电子发票 3查看电子发票
                        'refundStatus': 2 // 1申请退款 2退款中 3已完成退款s
                    }
                }, 
                
                {
                    courseName: '湖南省药师协会会费',
                    orderNumber: '202005168638292402',
                    payTime: '2020.12.12  14:19',
                    payMoney: '30.00',
                    payMethod: '办公室转学员',
                    operate: {
                        'electronicInvoiceleStatus': 3,  // 1申请电子发票 2已申请电子发票 3查看电子发票
                        'refundStatus': 3 // 1申请退款 2退款中 3已完成退款s
                    }
                },                 
            ],


    };
  },
    mounted: function () {
        document.getElementsByTagName("html")[0].className = "my-page";
    },
  methods: {
  

    




  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


@media (min-width: 1399px) {
    .el-container-master {
        width: 1400px;
        margin: auto;
    }
}

.el-aside {
    background: #fff
}
    
.el-main {
    padding: 0;
    background: #fff
}

.content {
    padding: 47px 57px 0 86px;
    flex:1;
    border-top: 10px solid #F8F8F8;
    border-left: 10px solid #F8F8F8;
}

.mockExamTable {
    margin-top:50px;
}



</style>

<style>
.mockExamCont .el-table {
    text-align: center;
}
.mockExamCont .el-table th {
    font-size:16px;
    color:#333;
    text-align: center;
    font-weight: bold;




}
.mockExamCont .el-table td {
    text-align: center;
}

.againExamBtn {
  height:42px;
  line-height: 42px;
  text-align: center;
  color:#fff;
  width:290px;
  margin:70px  auto 0;
  border-radius: 4px;
  cursor: pointer;
  letter-spacing: 2px;

}



</style>


// WEBPACK FOOTER //
// src/components/my/mockExam.vue